export default list => new Promise((resolve, reject) => {
     const dependant_size = list.length;

     const isLoaded = () => dependant_size === list.filter(obj_name => !!(obj_name.split('.').reduce((prev, curr) => prev ? prev[curr] : null, window))).length

     const keep_waiting = () => {
          setTimeout(() => {
               const is_loaded = isLoaded();

               if(is_loaded) resolve()
               else keep_waiting()
          }, 500)
     }

     keep_waiting();

     setTimeout(() => reject(), 10000) // Timeout: 10 seconds
})